<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <responsibility-form>
        </responsibility-form> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import ResponsibilityForm from './todo-responsibility-form'
export default {
    components: {
        ResponsibilityForm
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-responsibility-form/base-responsibility-form.vue